import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import AdminEditMainCharacter from "../../Components/Admin/AdminEditMainCharacter";
import SideBar from "../../Components/Admin/SideBar";

const AdminEditMainCharacterPage = () => {
  return (

    <AdminEditMainCharacter />

  );
};

export default AdminEditMainCharacterPage;